import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-cardKeyfact__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'.supt-cardKeyfact__label': fontStyle({
				...styles?.label?.typography,
				textAlign: styles?.label?.textAlignment,
				color: styles?.label?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		textAlign: 'center',
		borderStyle: 'solid',

		'.supt-cardKeyfact__title': cssObj(resetFirstLastMargins, {
			'&.supt-cardKeyfact__link': {
				textDecoration: 'none',
			},
		}),

		'.supt-cardKeyfact__label': resetFirstLastMargins,

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardKeyfact__title, .supt-cardKeyfact__label': {
				transition: `all ${transitions.mid} ease-out`,
			},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-keyfact-text"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			'.supt-card': {
				height: '100%',
			},

			p: {
				marginTop: '0px',
				marginRight: '0px',
				marginLeft: '0px',

				'&:first-child': {
					marginTop: '0px',
				},
			},
		},
	});

export { getStyles, getEditGlobalStyles };
